import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileMedicalHistoryEndocrine extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7_Endocrine";
    private medicalHistoryEndocrineOther = `${this.sectionId}_Other`;

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="col-md-12 flex-display section7-subfield padding-xs-top">
                <div className="flex-display">
                    {this.controlRenderer.renderInlineRadio({
                        value: section7.Endocrine.HasEndocrine,
                        items: this.getFalseTrueRadioOptionsWithoutLabel(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Endocrine.HasEndocrine = value),
                        id: `${this.sectionId}_HasEndocrine`,
                        className: "radios-one-label",
                        optionSpacing: "15px"
                    })}
                    <label className="margin-none margin-xs-left">{this.getString("EndocrineLabel")}</label>
                </div>
                <div className="width-100">
                    <div className="inline-flex-center">
                        {this.controlRenderer.renderCheckbox(
                            "Type1DiabetesAbbrevLabel",
                            section7.Endocrine.HasType1Diabetes,
                            value => this.mutateEndocrineModel(s => s.Section7.Endocrine.HasType1Diabetes = value, true),
                            "margin-sm-right margin-md-left"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "Type2DiabetesAbbrevLabel",
                            section7.Endocrine.HasType2Diabetes,
                            value => this.mutateEndocrineModel(s => s.Section7.Endocrine.HasType2Diabetes = value, true),
                            "margin-sm-right"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "PreviousGestationalDiabetesMellitusAbbrevLabel",
                            section7.Endocrine.HasPreviousGestationalDiabetesMellitus,
                            value => this.mutateEndocrineModel(s => s.Section7.Endocrine.HasPreviousGestationalDiabetesMellitus = value, true)
                        )}
                    </div>
                    {this.controlRenderer.renderCheckbox(
                        "ThyroidLabel",
                        section7.Endocrine.HasThyroid,
                        value => this.mutateEndocrineModel(s => s.Section7.Endocrine.HasThyroid = value, true),
                        "margin-md-left"
                    )}
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_Endocrine_Other`,
                        "ObstetricalFile_OtherLabel",
                        section7.Endocrine.Other.Value,
                        value => {
                            this.mutateEndocrineModel(
                                s => s.Section7.Endocrine.Other.Value = value,
                                true,
                                () => this.setFocusTextbox(value, this.medicalHistoryEndocrineOther)
                            );
                        },
                        this.getAdditionalTextBox({
                            id: this.medicalHistoryEndocrineOther,
                            value: section7.Endocrine.Other.Description,
                            onChange: value => this.mutateEndocrineModel(s => s.Section7.Endocrine.Other.setDescriptionAndCheckbox(value)),
                            maxLength: this.page1FieldLimits.MedicalHistory_Endocrine_OtherDescription.MaxChars,
                            valueClassName: "margin-xs-left"
                        }),
                        true,
                        "margin-md-left"
                    )}
                </div>
            </div>
        );
    }

    private mutateEndocrineModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (s.Section7.Endocrine.HasEndocrine == null)
                    s.Section7.Endocrine.HasEndocrine = s.Section7.Endocrine.hasSelectedAnyMedicalHistoryEndocrine();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileMedicalHistoryEndocrine };
